import { useState } from 'react';
import PropTypes from 'prop-types';

const SCOPE_MIN_LENGTH = 100;
const SCOPE_MAX_LENGTH = 10000;

const placeholderText = `Supply and installation of all materials, labor, and equipment including:
* Provision of materials as per specifications
* Installation in accordance with standards and regulations
* Quality assurance and testing procedures
* Site cleanup and waste disposal...`;

const validateScopeText = (text) => {
  if (!text.trim()) {
    return ''; // Optional field, no error when empty
  }
  if (text.length < SCOPE_MIN_LENGTH) {
    return `Scope of Works must be at least ${SCOPE_MIN_LENGTH} characters when provided`;
  }
  if (text.length > SCOPE_MAX_LENGTH) {
    return `Scope of Works cannot exceed ${SCOPE_MAX_LENGTH.toLocaleString()} characters`;
  }
  return '';
};

const AdditionalDocumentsSection = ({
  scopeText,
  onScopeTextChange,
  error,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleTextChange = (e) => {
    const newText = e.target.value;
    onScopeTextChange(newText, validateScopeText(newText));
  };

  return (
    <div>
      <div className="um-sec-head">
        <div className="um-sec-head-main">
          <h2 className="um-sec-title">Additional documents</h2>
        </div>
      </div>
      <button
        type="button"
        className={`um-disclosure ${isExpanded ? 'open' : ''}`}
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M9 6l6 6-6 6" />
        </svg>
        <span className="d-title">Scope of works</span>
        <span className="um-chip tone-neutral">Optional</span>
      </button>
      {isExpanded && (
        <div className="um-disclosure-body">
          <p className="um-scope-hint" id="um-scope-hint">
            Enter your specification text to enable AI-powered compliance
            analysis of your quotes.
          </p>
          <textarea
            className="um-scope-textarea"
            aria-label="Scope of works"
            aria-describedby="um-scope-hint"
            value={scopeText}
            onChange={handleTextChange}
            placeholder={placeholderText}
          />
          <p className="um-scope-counter">
            {scopeText.length}/{SCOPE_MAX_LENGTH.toLocaleString()} characters
          </p>
          {error && <p className="um-field-error">{error}</p>}
        </div>
      )}
    </div>
  );
};

AdditionalDocumentsSection.propTypes = {
  scopeText: PropTypes.string,
  onScopeTextChange: PropTypes.func.isRequired,
  error: PropTypes.string,
};

export default AdditionalDocumentsSection;
